/* ============================================================
   Footer — Editorial. Back-to-top behaviour for the wordmark
   marquee and the base-bar button. Newsletter submission is
   handled natively by Shopify's {% form 'customer' %}.
   ============================================================ */
(function () {
  function toTop() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  }

  function init(root) {
    if (!root || root.__bfInit) return;
    root.__bfInit = true;
    root.querySelectorAll('[data-bf-top]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        toTop();
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bigfoot]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bigfoot]');
    if (root) init(root);
  });
})();
